const taxSystems = [
    {
        text: 'Régime Général/Ex Pinel/Rp',
        value: 'Pinel / Rés. principale',
        color: '#f44336',
        family: 'VEFA',
    },
    {
        text: 'Denormandie',
        value: 'Denormandie',
        color: '#E91E63',
        family: 'ANCIEN',
    },
    {
        text: 'Malraux',
        value: 'Malraux',
        color: '#9C27B0',
        family: 'ANCIEN',
    },
    {
        text: 'Monuments historiques',
        value: 'Monuments historiques',
        color: '#673AB7',
        family: 'ANCIEN',
    },
    {
        text: 'Déficits fonciers',
        value: 'Déficits fonciers',
        color: '#4CAF50',
        family: 'ANCIEN',
    },
    /* Demande Eric 25-01-2022{
        text: 'Projet construction',
        value: 'Projet construction',
        color: '#009688',
        family: 'ANCIEN',
    },*/
    {
        text: 'Démembrement/Nue Prop',
        value: 'Démembrement de propriété',
        color: '#FFEB3B',
        family: 'VEFA',
    },
    {
        text: 'Biens de Rapport',
        value: 'Revente fin défiscalisation',
        color: '#FFC107',
        family: 'LMNPREV',
    },
    {
        text: 'RP Tva Réduite/Prix Maitrisé',
        value: 'RP Tva Réduite/Prix Maitrisé',
        color: '#FF9800',
        family: 'VEFA',
    },
    {
        text: 'LLI Locatif TVA 10%',
        value: 'LLI',
        color: '#4CAF50',
        family: 'VEFA',
    },
    {
        text: 'BRS',
        value: 'BRS',
        color: '#795548',
        family: 'VEFA',
    },
    {
        text: 'Loi COSSE',
        value: 'Loi COSSE Ancien-Louer Abordable',
        color: '#607D8B',
        family: 'ANCIEN',
    },
    {
        text: 'LMNP VEFA Divers',
        value: 'LMNP VEFA Divers',
        color: '#42A5F5',
        family: 'LMNPVEFA',
    },
    {
        text: 'LMNP Étudiant',
        value: 'LMNP Étudiant',
        color: '#2196F3',
        family: 'LMNPVEFA',
    },
    {
        text: 'LMNP Sénior',
        value: 'LMNP Senior',
        color: '#1E88E5',
        family: 'LMNPVEFA',
    },
    {
        text: 'LMNP Tourisme: mer/montagne',
        value: 'LMNP Tourisme',
        color: '#1976D2',
        family: 'LMNPVEFA',
    },
    {
        text: 'LMNP Rés. d\'affaires',
        value: 'LMNP Rés. d\'affaires',
        color: '#1976D2',
        family: 'LMNPVEFA',
    },
    {
        text: 'LMNP EHPAD: maison de retraite',
        value: 'LMNP EHPAD',
        color: '#1565C0',
        family: 'LMNPVEFA',
    },
    {
        text: 'LMNP Coliving',
        value: 'LMNP Coliving',
        color: '#1565C0',
        family: 'LMNPVEFA',
    },
    {
        text: 'LMNP Colocation',
        value: 'LMNP Colocation',
        color: '#1565C0',
        family: 'LMNPVEFA',
    },
    {   text: 'LMNP CRT',
        value: 'LMNP CRT',
        color: '#1565C0',
        family: 'LMNPVEFA',
    },
    {   text: 'CIIC Corse',
        value: 'CIIC Corse',
        color: '#1565C0',
        family: 'LMNPVEFA',
    },
    {
        text: 'Revente LMNP Divers',
        value: 'Revente LMNP',
        color: '#2196F3',
        family: 'LMNPREV',
    },
    {
        text: 'Revente LMNP Étudiant',
        value: 'Revente LMNP Étudiant',
        color: '#2196F3',
        family: 'LMNPREV',
    },
    {
        text: 'Revente LMNP Sénior',
        value: 'Revente LMNP Sénior',
        color: '#1E88E5',
        family: 'LMNPREV',
    },
    {
        text: 'Revente LMNP Tourisme: mer/montagne',
        value: 'Revente LMNP Tourisme',
        color: '#1976D2',
        family: 'LMNPREV',
    },
    {
        text: 'Revente LMNP Rés. d\'affaires',
        value: 'Revente LMNP Rés',
        color: '#1976D2',
        family: 'LMNPREV',
    },
    {
        text: 'Revente LMNP EHPAD: maison de retraite',
        value: 'Revente LMNP EHPAD',
        color: '#1565C0',
        family: 'LMNPREV',
    },
    {
        text: 'Ex PINEL Sénior / RP',
        value: 'PINEL Sénior',
        color: '#E64A19',
        family: 'VEFA',
    },
    {
        text: 'RP/Ex PINEL Ancien',
        value: 'PINEL Ancien',
        color: '#D84315',
        family: 'ANCIEN',
    },
    {
        text: 'Ex Pinel Outre Mer/RP',
        value: 'PINEL Outre Mer',
        color: '#BF360C',
        family: 'VEFA',
    },
    {
        text: 'Locaux Commerciaux',
        value: 'Local commerce',
        color: '#BF360C',
        family: 'LOCALPRO',
    },
    {
        text: 'Plateaux de Bureaux',
        value: 'Plateau Bureau',
        color: '#BF360C',
        family: 'LOCALPRO',
    },
    {
        text: 'Entrepôts',
        value: 'Entrepôt',
        color: '#BF360C',
        family: 'LOCALPRO',
    },
    {
        text: 'Immeubles de Rapport',
        value: 'Rapport',
        color: '#BF360C',
        family: 'LOCALPRO',
    },
];

export default taxSystems;

export function getTaxSystemColor(taxSystem: string) {
    const sys = taxSystems.find(sys => sys.value === taxSystem);
    return sys ? sys.color : null;
}

export function getTaxSystemValue(taxSystem: string) {
    const sys = taxSystems.find(sys => sys.value === taxSystem);
    return sys ? sys.text : null;
}
